import { useSyncExternalStore } from 'react';
import { translate, type Locale } from './core';
import { localeRepository } from './repository';

let locale = localeRepository.read();
const listeners = new Set<() => void>();
const subscribe = (listener: () => void) => { listeners.add(listener); return () => listeners.delete(listener); };
export const getLocale = () => locale;
export function setLocale(next: Locale, remember = true) {
  if (remember) localeRepository.write(next);
  if (next === locale) return;
  locale = next;
  listeners.forEach(listener => listener());
  window.dispatchEvent(new Event('designforge:locale'));
}
export function useLocale() { return useSyncExternalStore(subscribe, getLocale); }
export function useTranslation() {
  const current = useLocale();
  function tr(message: string): string;
  function tr(message: string | undefined): string | undefined;
  function tr(message: string | undefined) { return translate(current, message); }
  return tr;
}
